/**
 * 通用字典接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SwExportService } from 'src/app/librarys/serves/public/sw-export.service';

@Injectable({
  providedIn: 'root'
})
export class DictionaryService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
     private exportService : SwExportService
   ) {
   }

  //#region 通用字典接口
  /**
   * 查询通用字典所有信息
   * @param param
   * @returns {Observable<any>}
   */
  queryDictionaryPageList(param) {
    const url = this.prefix + 'dictionary/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 查看通用字典信息
   * @param param
   * @returns {Observable<any>}
   */
  getDictionary(param) {
    const url = this.prefix + 'dictionary/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 更新通用字典信息
   * @param param
   * @returns {Observable<any>}
   */
  updateDictionary(param) {
    const url = this.prefix + 'dictionary/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 删除通用字典单个信息
   * @param param
   * @returns {Observable<any>}
   */
  deleteDictionary(param) {
    const url = this.prefix + 'dictionary/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 增加通用字典单个信息
   * @param param
   * @returns {Observable<any>}
   */
  saveDictionary(param) {
    const url = this.prefix + 'dictionary/save';
    return this.http.Post(url, param);
  }

  /**
   * 导出通用字典
   * @param param
   * @returns {Observable<any>}
   */
  exportDictionary(param) {
    const url = this.prefix + 'dictionary/export?parentId=' + param;
    this.exportService.getExportExcel(url,'通用字典')
  }

  /**
   * 根据code查询字典项
   *
   * @param param
   * @returns {Observable<any>}
   */
  getDictionaryByCode(param) {
    const url = this.prefix + 'dictionary/queryDictionaryByCode';
    return this.http.Post(url, param);
  }

  //#endregion

}
